import { render, staticRenderFns } from "./PermissaoWizardDialog.vue?vue&type=template&id=cbba761c&scoped=true&"
import script from "./PermissaoWizardDialog.vue?vue&type=script&lang=js&"
export * from "./PermissaoWizardDialog.vue?vue&type=script&lang=js&"
import style0 from "./PermissaoWizardDialog.vue?vue&type=style&index=0&id=cbba761c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbba761c",
  null
  
)

export default component.exports